import { dispatchEvent } from 'redux-ruleset'
import { Product } from 'utils/productListFetcher/types'
import * as t from 'hooks/account/types'

export type ExtendedCartItem = {
  product: Product | null
  amount: number
  totalPrice: number
  unitPrice: number
  tracking?: {
    packPriceNet: number
    piecePriceNet: number
  }
}

export type ClipboardFieldName =
  | 'all'
  | 'receiver'
  | 'iban'
  | 'BIC'
  | 'amount'
  | 'purpose'

export const ORDER_FAILED: 'checkout/ORDER_FAILED' = 'checkout/ORDER_FAILED'
export const PURCHASE: 'checkout/PURCHASE' = 'checkout/PURCHASE'
export const SHIPPING_INFO: 'checkout/SHIPPING_INFO' = 'checkout/SHIPPING_INFO'
export const PAYMENT_INFO: 'checkout/PAYMENT_INFO' = 'checkout/PAYMENT_INFO'
export const ORDER_SUCCESS: 'checkout/ORDER_SUCCESS' = 'checkout/ORDER_SUCCESS'
export const COPY_TO_CLIPBOARD: 'checkout/COPY_TO_CLIPBOARD' =
  'checkout/COPY_TO_CLIPBOARD'

export const copyToClipboard = (fieldName: ClipboardFieldName) =>
  dispatchEvent({
    type: COPY_TO_CLIPBOARD,
    fieldName
  })

export const orderSuccess = (orderId: string, isPaypalExpress: boolean) =>
  dispatchEvent({
    type: ORDER_SUCCESS,
    orderId,
    isPaypalExpress
  })

export const orderFailed = (orderId, error: string) =>
  dispatchEvent({
    type: ORDER_FAILED,
    meta: { orderId },
    payload: { error }
  })
export const shippingInfo = (
  cart: t.Cart,
  shippingName: string,
  paymentName: string
) =>
  dispatchEvent({
    type: SHIPPING_INFO,
    meta: {},
    payload: { cart, shippingName, paymentName }
  })
export const paymentInfo = (cart: t.Cart, activePayment: string) =>
  dispatchEvent({
    type: PAYMENT_INFO,
    cart,
    activePayment
  })

export const purchase = (
  order: t.Order,
  items: ExtendedCartItem[],
  shippingName: string,
  paymentType: string,
  b2bCustomer: string,
  isOutsideSalesRep: boolean
) =>
  dispatchEvent({
    type: PURCHASE,
    meta: { order },
    payload: {
      items,
      shippingName,
      paymentType,
      b2bCustomer,
      isOutsideSalesRep
    }
  })

export type OrderFailed = ReturnType<typeof orderFailed>
export type Purchase = ReturnType<typeof purchase>
export type ShippingInfo = ReturnType<typeof shippingInfo>
export type PaymentInfo = ReturnType<typeof paymentInfo>
export type OrderSuccess = ReturnType<typeof orderSuccess>
export type CopyToClipboard = ReturnType<typeof copyToClipboard>

export type Event =
  | OrderFailed
  | Purchase
  | PaymentInfo
  | ShippingInfo
  | OrderSuccess
  | CopyToClipboard

declare global {
  interface RulesetDispatchEvents {
    'checkout/Success': Event
  }
}
